<template>
  <div class="main">
    <div class="form-row-line col-4">
      <div class="form-field">
        <label for="total-sum">Баланс:</label>
        <input id="total-sum" v-model="balance" disabled />
      </div>
      <div class="form-field">
        <label for="pay-sum">Сумма оплаты:</label>
        <input id="pay-sum" type="number" v-model="paymentSum" />
      </div>
      <div class="form-field">
        <button @click="sendPayment" v-bind:class="{ disable: paymentSum < 1 }">
          Пополнить
        </button>
      </div>
    </div>
    <div class="content">
      <div class="content_title">
        Пополнения
      </div>
      <div class="content_row col-4" v-for="(ref, key) in refill" :key="key">
        <div>
          {{ ref.DATE }}
        </div>
        <div>
          {{ ref.SUM }}
        </div>
        <div>
          {{ ref.SOURCE_REFILL }}
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_title">
        Списания
      </div>
      <div
        class="content_row col-4"
        v-for="(offs, key) in writeoffs"
        :key="key"
      >
        <div>
          {{ offs.DATE }}
        </div>
        <div>
          {{ offs.BASE_WRITE_OFFS }}
        </div>
        <div>
          {{ offs.SUM }}
        </div>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "Payment",

  data() {
    return {
      agreementId: this.$route.params.id,
      url: config.backend_url,
      balance: null,
      paymentSum: null,
      writeoffs: [],
      refill: [],
      info: null
    };
  },
  computed: {},
  methods: {
    getPayment: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "refill/get/",
          filter: { TERMS_OF_USE: self.agreementId },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.refill = data;
          }
        });
    },
    sendPayment: function() {
      let self = this;
      if (self.paymentSum > 0) {
        this.$store
          .dispatch("query/sendRequest", {
            url: self.url + "refill/add/",
            data: {
              TERMS_OF_USE: self.agreementId,
              SUM: self.paymentSum,
              SOURCE_REFILL: "online"
            },
            method: "POST"
          })
          .then(function(response) {
            let data = response.data;
            if (!data.error && data.refill) {
              self.getData();
              self.getPayment();
            }
          });
      }
    },
    getData: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "agreements/get-all-data/",
          filter: { ID: self.agreementId },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.balance = parseInt(data.AGREEMENT.BALANCE);
            self.paymentSum = self.balance < 0 ? self.balance * -1 : 0;
            self.writeoffs = data.WRITEOFFS;
          }
        });
    }
  },
  created() {
    this.getData();
    this.getPayment();
  }
};
</script>
